import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { CreateVersionModalProps, VersionSchema, VersionType } from "@/types";
import { versionToString } from "@/util";
import { createVersionApiStore, projectStore } from "@/hooks";
import { Modal, TextButton, FlexBox } from "@/components/common";


/**
 * A modal for creating new versions.
 */
const __default__ = {
  name: "CreateVersionModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    project: {}
  },
  emits: ["close", "create"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const versionName = computed(() => versionToString(projectStore.version));

/**
 * Returns the next version name.
 * @param type - The type of new version.
 */
function nextVersion(type: VersionType): string {
  if (projectStore.version === undefined) {
    return "X.X.X";
  }

  const { majorVersion, minorVersion, revision } = projectStore.allVersions[0];

  switch (type) {
    case "major":
      return `${majorVersion + 1}.0.0`;
    case "minor":
      return `${majorVersion}.${minorVersion + 1}.0`;
    case "revision":
      return `${majorVersion}.${minorVersion}.${revision + 1}`;
  }
}

/**
 * Creates a new version.
 * @param versionType - The version type to create.
 */
function handleClick(versionType: VersionType) {
  if (!props.project) return;

  createVersionApiStore.handleCreate(props.project.projectId, versionType, {
    onSuccess: (version) => emit("create", version),
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    title: `Current Version: ${versionName.value}`,
    open: props.open,
    loading: _unref(createVersionApiStore).loading,
    "data-cy": "modal-version-create",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        column: "",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            label: `New Major Version: ${nextVersion('major')}`,
            color: "primary",
            "data-cy": "button-create-major-version",
            onClick: _cache[0] || (_cache[0] = () => handleClick('major'))
          }, null, 8, ["label"]),
          _createVNode(_unref(TextButton), {
            text: "",
            label: `New Minor Version: ${nextVersion('minor')}`,
            color: "primary",
            "data-cy": "button-create-minor-version",
            onClick: _cache[1] || (_cache[1] = () => handleClick('minor'))
          }, null, 8, ["label"]),
          _createVNode(_unref(TextButton), {
            text: "",
            label: `New Revision: ${nextVersion('revision')}`,
            color: "primary",
            "data-cy": "button-create-revision-version",
            onClick: _cache[2] || (_cache[2] = () => handleClick('revision'))
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "open", "loading"]))
}
}

})